import { Tooltip } from '@mui/material';
import { useConfirm } from 'material-ui-confirm';
import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Help as HelpIcon } from './icons/help';

type Props =
  | {
      variant?: 'tooltip';
      content: ReactNode;
      title: undefined;
    }
  | {
      variant: 'dialog';
      title: ReactNode;
      content: ReactNode;
    };

export type HelpButtonProps = Props;

export const HelpButton = ({ variant = 'tooltip', content, title }: Props) => {
  const confirm = useConfirm();

  const openDialog = () => {
    confirm({
      title,
      description: content,
      confirmationText: <FormattedMessage id="close" defaultMessage="Zavřít" />,
      hideCancelButton: true,
    })
      .then(() => {
        // noop
      })
      .catch(() => {
        // noop
      });
  };

  if (variant === 'tooltip') {
    return (
      <Tooltip title={content}>
        <HelpIcon sx={{ fontSize: 13, ml: 0.75 }} />
      </Tooltip>
    );
  }

  if (variant === 'dialog') {
    return <HelpIcon sx={{ fontSize: 13, ml: 0.75 }} onClick={openDialog} />;
  }

  return null;
};
